/* ===== 1) Real viewport height CSS var ==================================== */
(function () {
  const root = document.documentElement;
  let rafId = 0;

  function setRealVh() {
    rafId = 0;
    const vh = (window.visualViewport ? window.visualViewport.height : window.innerHeight) * 0.01;
    root.style.setProperty('--vh', `${vh}px`);
  }

  function scheduleSetRealVh() {
    if (rafId) return;
    rafId = requestAnimationFrame(setRealVh);
  }

  scheduleSetRealVh();

  window.addEventListener('resize', scheduleSetRealVh, { passive: true });
  window.addEventListener('orientationchange', scheduleSetRealVh, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSetRealVh, { passive: true });
  }
})();

/* ===== 2) Header-Behaviour, Logo, Hover, Video-Delay, Language Switcher === */
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.section-header');
  const mainNav = document.getElementById('main-nav');
  const pageHeader = document.querySelector('.pageheader');
  const navigation = document.querySelectorAll('.navigation');

  let hoverTimeout = 0;

  /* --- Scroll-/Header-State ------------------------------------------------ */
  const collapseAt = 360;
  let lastScrollY = Math.max(0, window.scrollY || 0);
  let headerState = lastScrollY > collapseAt ? 'collapsed' : 'expanded';
  let scrolledSinceChange = true;
  let ticking = false;

  function setHeaderActiveStyles(isActive) {
    if (!header) return;

    header.classList.toggle('header-active', isActive);

    if (pageHeader) {
      pageHeader.style.backgroundColor = isActive ? '#ffffff' : 'rgba(255,255,255,0)';
    }

    navigation.forEach((nav) => {
      nav.style.backgroundColor = isActive ? '#ffffff' : 'rgba(255,255,255,0)';
    });
  }

  function applyHeaderVisual(currentY) {
    if (!header) return;
    const makeActive = (headerState === 'collapsed') || currentY > 0;
    setHeaderActiveStyles(makeActive);
  }

  function changeLogo() {
    const logoMain = document.getElementById('logo-main');
    const logoNav = document.getElementById('logo-nav');
    if (!logoMain || !logoNav) return;

    if (headerState === 'collapsed') {
      if (!logoMain.classList.contains('slideUp')) {
        logoMain.classList.remove('slidedown');
        logoMain.classList.add('slideUp');
      }
      logoNav.className = 'navigation__item navigation__item--with-children navigation__item--with-small-menu navigation__item--active logo-small';
    } else {
      if (!logoMain.classList.contains('slidedown')) {
        logoMain.classList.remove('slideUp');
        logoMain.classList.add('slidedown');
      }
      logoNav.className = 'logo-small-none';
    }
  }

  function handleScrollFrame() {
    ticking = false;

    const currentY = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);

    if (headerState === 'expanded') {
      if (scrolledSinceChange && currentY > collapseAt) {
        headerState = 'collapsed';
        scrolledSinceChange = false;
      }
    } else {
      if (scrolledSinceChange && currentY === 0) {
        headerState = 'expanded';
        scrolledSinceChange = false;
      }
    }

    applyHeaderVisual(currentY);
    changeLogo();
  }

  function onScroll() {
    const currentY = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);

    if (Math.abs(currentY - lastScrollY) >= 1) {
      scrolledSinceChange = true;
      lastScrollY = currentY;
    }

    if (!ticking) {
      ticking = true;
      requestAnimationFrame(handleScrollFrame);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  applyHeaderVisual(lastScrollY);
  changeLogo();

  /* --- Hover für Navigation ----------------------------------------------- */
  if (mainNav) {
    mainNav.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      setHeaderActiveStyles(true);
    });

    mainNav.addEventListener('mouseleave', () => {
      hoverTimeout = window.setTimeout(() => {
        const currentY = Math.max(0, window.scrollY || document.documentElement.scrollTop || 0);
        if (headerState === 'expanded' && currentY === 0) {
          setHeaderActiveStyles(false);
        }
      }, 300);
    });
  }

  /* --- Video delayed sections (Produktseiten) ------------------------------ */
  if (document.querySelector('.template-product')) {
    const delayedSections = document.querySelectorAll('.delayed-section');
    const video = document.querySelector('.video-section--background video');

    function revealDelayedSections() {
      delayedSections.forEach((section) => {
        section.classList.add('reveal');
      });
    }

    if (video) {
      video.addEventListener('canplaythrough', revealDelayedSections, { once: true });
      window.setTimeout(revealDelayedSections, 800);
    } else {
      revealDelayedSections();
    }
  }

  /* --- Language Switcher (Desktop & Mobile) ------------------------------- */
  const triggerIcons = document.querySelectorAll('.language-icon');
  const desktopSwitcher = document.getElementById('language-switcher');
  const mobileSwitcher = document.getElementById('language-switcherMobileNav');

  if (triggerIcons.length > 0) {
    function getActiveSwitcher() {
      return window.innerWidth <= 768 ? mobileSwitcher : desktopSwitcher;
    }

    function showSwitcher(switcher) {
      if (!switcher) return;
      switcher.style.display = 'block';
    }

    function hideSwitcher(switcher) {
      if (!switcher) return;
      switcher.style.display = 'none';
    }

    function toggleSwitcher(switcher) {
      if (!switcher) return;
      switcher.style.display = switcher.style.display === 'block' ? 'none' : 'block';
    }

    triggerIcons.forEach((icon) => {
      icon.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleSwitcher(getActiveSwitcher());
      });

      icon.addEventListener('mouseenter', function () {
        if (window.innerWidth > 768) {
          clearTimeout(hoverTimeout);
          showSwitcher(desktopSwitcher);
        }
      });

      icon.addEventListener('mouseleave', function () {
        if (window.innerWidth > 768 && desktopSwitcher) {
          clearTimeout(hoverTimeout);
          hoverTimeout = window.setTimeout(() => {
            if (!desktopSwitcher.matches(':hover')) {
              hideSwitcher(desktopSwitcher);
            }
          }, 250);
        }
      });
    });

    if (desktopSwitcher) {
      desktopSwitcher.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimeout);
        showSwitcher(desktopSwitcher);
      });

      desktopSwitcher.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimeout);
        hoverTimeout = window.setTimeout(() => {
          const anyIconHovered = Array.from(triggerIcons).some((icon) => icon.matches(':hover'));
          if (!anyIconHovered && !desktopSwitcher.matches(':hover')) {
            hideSwitcher(desktopSwitcher);
          }
        }, 250);
      });
    }

    [desktopSwitcher, mobileSwitcher].forEach((switcher) => {
      if (!switcher) return;
      switcher.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener('click', function () {
      hideSwitcher(desktopSwitcher);
      hideSwitcher(mobileSwitcher);
    });
  }
});

/* ===== 3) Flatpickr nur auf Mieteseiten =================================== */
if (window.location.href.includes('miete')) {
  document.addEventListener('DOMContentLoaded', function () {
    const startField = document.getElementById('start_date');
    const endField = document.getElementById('end_date');

    if (typeof flatpickr !== 'undefined' && startField && endField) {
      const startPicker = flatpickr(startField, {
        dateFormat: 'd.m.Y',
        onChange: function (selectedDates) {
          if (selectedDates.length && endPicker) {
            endPicker.set('minDate', selectedDates[0]);
          }
        }
      });

      const endPicker = flatpickr(endField, {
        dateFormat: 'd.m.Y',
        onChange: function (selectedDates) {
          if (selectedDates.length && startPicker) {
            startPicker.set('maxDate', selectedDates[0]);
          }
        }
      });
    }
  });
}

/* ===== 4) Messung der vollen Headerhöhe & CSS-Variablen setzen ============ */
(function () {
  const root = document.documentElement;

  const headerSection =
    document.querySelector('[id^="shopify-section-sections"][class*="section-header"]') ||
    document.querySelector('.section-header');

  const pageHeader = document.querySelector('.pageheader');
  const measureTarget = headerSection || pageHeader;

  if (!measureTarget) return;

  let rafId = 0;
  let lastHeight = -1;

  function readHeaderHeight() {
    return Math.round(measureTarget.offsetHeight || 0);
  }

  function applyHeaderHeight(height) {
    if (height <= 0 || height === lastHeight) return;
    lastHeight = height;
    const px = `${height}px`;
    root.style.setProperty('--full-header-height', px);
    root.style.setProperty('--theme-header-height', px);
  }

  function measureNow() {
    rafId = 0;
    applyHeaderHeight(readHeaderHeight());
  }

  function scheduleMeasure() {
    if (rafId) return;
    rafId = requestAnimationFrame(measureNow);
  }

  window.addEventListener('load', scheduleMeasure, { once: true });
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  window.addEventListener('orientationchange', scheduleMeasure, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleMeasure, { passive: true });
  }

  scheduleMeasure();
  requestAnimationFrame(() => requestAnimationFrame(scheduleMeasure));

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleMeasure).catch(() => {});
  }

  new MutationObserver(scheduleMeasure).observe(measureTarget, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  if ('ResizeObserver' in window) {
    new ResizeObserver(scheduleMeasure).observe(measureTarget);
  }
})();